module.exports = __webpack_public_path__ + "static/media/gradientBackgroundGoldCard.35178ac1.png";